import request from '@/utils/request'
// 首页轮播图
export function getHomeSWipe (data) {
  return request({
    url: '/AdvertisingImgApi/Index',
    method: 'post',
    data
  })
}
// 合作伙伴
export function getCooperative (data) {
  return request({
    url: '/CooperativeApi/Index',
    method: 'post',
    data
  })
}
// 产品线
export function getProductTypeIndex (data) {
  return request({
    url: '/ProductApi/ProductTypeIndex',
    method: 'post',
    data
  })
}
